<c-row>
  <c-col xs="12">
    <c-card class="mb-12">
      <c-card-header ngPreserveWhitespaces>
        <strong>Mantenimiento Maestros Socios - Actualizar</strong>
        <small></small>
      </c-card-header>

      <c-card-body>
        <c-row>
          <c-col xs="12">
            <form
              cForm
              [formGroup]="editarForm"
              (ngSubmit)="showGuardarSocio()"
            >
              <c-row>
                <c-col>
                  <label cLabel for="exampleFormControlInput1">Planta</label>
                  <select
                    aria-label="Default select example"
                    cSelect
                    formControlName="planta"
                  >
                    <option
                      *ngFor="let element of listaPlantas"
                      [(ngValue)]="element.id"
                    >
                      {{ element.id }} {{ element.description }}
                    </option>
                  </select>
                </c-col>

                <c-col>
                  <label cLabel for="exampleFormControlInput1"
                    >Número de Socio</label
                  >
                  <input
                    cFormControl
                    id="noSocio"
                    formControlName="noSocio"
                    placeholder=""
                    type="number"
                    name="noSocio"
                    min="1"
                  />
                </c-col>
              </c-row>
              <c-row class="mt-2">
                <c-col>
                  <label cLabel for="exampleFormControlInput1"
                    >Nivel del Socio</label
                  >
                  <select
                    aria-label="Default select example"
                    formControlName="levelPartner"
                    cSelect
                  >
                    <option
                      *ngFor="let element of listaNivelSocio"
                      [value]="element.cveValue"
                    >
                      {{ element.cveValue }} {{ element.description }}
                    </option>
                  </select>
                </c-col>
                <c-col>
                  <label cLabel for="exampleFormControlInput1"
                    >Tipo de Socio</label
                  >
                  <select
                    aria-label="Default select example"
                    formControlName="typePartner"
                    cSelect
                    (ngModelChange)="eventTipoSocio($event)"
                  >
                    <option
                      *ngFor="let element of listaTipoSocio"
                      [value]="element.cveValue"
                    >
                      {{ element.cveValue }} {{ element.description }}
                    </option>
                  </select>
                </c-col>

                <c-col>
                  <label cLabel for="exampleFormControlInput1"
                    >Tipo Proveedor</label
                  >
                  <input
                    cFormControl
                    id="supplierType"
                    placeholder=""
                    type="text"
                    formControlName="supplierType"
                  />
                </c-col>
                <c-col>
                  <label cLabel for="exampleFormControlInput1"
                    >Razón Social</label
                  >
                  <input
                    cFormControl
                    id="razonSocial"
                    placeholder=""
                    type="text"
                    formControlName="razonSocial"
                  />
                </c-col>
                <c-col>
                  <label cLabel for="exampleFormControlInput1">Nombre</label>
                  <input
                    cFormControl
                    id="nombre"
                    placeholder=""
                    type="text"
                    formControlName="nombre"
                  />
                </c-col>
              </c-row>
              <c-row class="mt-2">
                <c-col>
                  <label cLabel for="exampleFormControlInput1">RFC</label>
                  <input
                    cFormControl
                    id="rfc"
                    placeholder=""
                    type="text"
                    formControlName="rfc"
                  />
                </c-col>
                <c-col>
                  <label cLabel for="exampleFormControlInput1">CURP</label>
                  <input
                    cFormControl
                    id="curp"
                    placeholder=""
                    type="text"
                    formControlName="curp"
                  />
                </c-col>
                <c-col>
                  <label cLabel for="exampleFormControlInput1"
                    >Grupo Aparcería</label
                  >
                  <select
                    aria-label="Default select example"
                    formControlName="grupoAparceria"
                    cSelect
                  >
                    <option
                      *ngFor="
                        let element of listaGrupoAparceria.valueSetDetailResponse
                      "
                      [value]="element.cveValue"
                    >
                      {{ element.cveValue }} {{ element.description }}
                    </option>
                  </select>
                </c-col>
              </c-row>
              <c-row class="mt-2">
                <c-col>
                  <label cLabel for="exampleFormControlInput1"
                    >Reg. Recolec.</label
                  >
                  <select
                    aria-label="Default select example"
                    formControlName="regRecolec"
                    cSelect
                  >
                    <option
                      *ngFor="let element of listaRutaRecolecion"
                      [value]="element.numero"
                    >
                      {{ element.numero }} {{ element.descripcion }}
                    </option>
                  </select>
                </c-col>
                <c-col>
                  <label cLabel for="exampleFormControlInput1"
                    >Grupo Arrendador</label
                  >
                  <select
                    aria-label="Default select example"
                    formControlName="grupoArrendador"
                    cSelect
                  >
                    <option
                      *ngFor="let element of listaGrupoArrendador"
                      [value]="element.cveValue"
                    >
                      {{ element.description }}
                    </option>
                  </select>
                </c-col>

                <c-col>
                  <label cLabel for="exampleFormControlInput1"
                    >% Partic. Arrend.</label
                  >
                  <input
                    cFormControl
                    id="particArrend"
                    placeholder=""
                    type="number"
                    formControlName="particArrend"
                  />
                </c-col>
              </c-row>

              <hr class="mt-4 mb-4" />
              <c-row>
                <c-col xs="6">
                  <div>
                    <label cLabel>Zona Geográfica</label>
                    <select
                      aria-label="Default select example"
                      formControlName="zonaGeografica"
                      cSelect
                    >
                      <option
                        *ngFor="
                          let element of listaZonasGeograficas.valueSetDetailResponse
                        "
                        [value]="element.cveValue"
                      >
                        {{ element.cveValue }} {{ element.description }}
                      </option>
                    </select>
                  </div>
                  <div>
                    <label cLabel>Estado</label>
                    <select
                      aria-label="Default select example"
                      formControlName="estado"
                      #estado
                      cSelect
                      (change)="handleChangeEstado(estado.value)"
                    >
                      <option
                        *ngFor="let element of listaStates"
                        [value]="element.cveEnt"
                      >
                        {{ element.nomEnt }}
                      </option>
                    </select>
                  </div>
                  <div>
                    <label cLabel>Municipio</label>
                    <select
                      aria-label="Default select example"
                      formControlName="municipio"
                      cSelect
                    >
                      <option
                        *ngFor="let element of listaMunicipio"
                        [value]="element.cveMun"
                      >
                        {{ element.nomMun }}
                      </option>
                    </select>
                  </div>
                  <div>
                    <label cLabel>Grupo de Estado</label>
                    <select
                      aria-label="Default select example"
                      formControlName="region"
                      cSelect
                    >
                      <option
                        *ngFor="let element of listaReg"
                        [value]="element.id"
                      >
                        {{ element.descripcion }}
                      </option>
                    </select>
                  </div>
                  <div>
                    <label cLabel>Dirección Fiscal</label>
                    <input
                      cFormControl
                      id="direccion"
                      placeholder=""
                      type="text"
                      formControlName="direccion"
                    />
                  </div>
                  <div>
                    <label cLabel>Dirección Rancho</label>
                    <input
                      cFormControl
                      id="ranchAddress"
                      placeholder=""
                      type="text"
                      required
                      formControlName="ranchAddress"
                    />
                  </div>
                  <div>
                    <label cLabel>Email</label>
                    <input
                      cFormControl
                      id="email"
                      placeholder=""
                      type="email"
                      formControlName="email"
                    />
                  </div>
                </c-col>

                <c-col xs="6">
                  <div>
                    <label cLabel>Telefono 1</label>
                    <input
                      cFormControl
                      id="tel1"
                      placeholder=""
                      type="text"
                      formControlName="tel1"
                    />
                  </div>
                  <div>
                    <label cLabel>Telefono 2</label>
                    <input
                      cFormControl
                      id="tel2"
                      placeholder=""
                      type="text"
                      formControlName="tel2"
                    />
                  </div>
                  <div>
                    <label cLabel>Telefono 3</label>
                    <input
                      cFormControl
                      id="tel3"
                      placeholder=""
                      type="text"
                      formControlName="tel3"
                    />
                  </div>
                  <div>
                    <label cLabel>CP</label>
                    <input
                      cFormControl
                      id="cp"
                      placeholder=""
                      type="text"
                      formControlName="cp"
                    />
                  </div>
                  <div>
                    <label cLabel for="exampleFormControlInput1">Estatus</label>
                    <select
                      aria-label="Default select example"
                      formControlName="tipoEstatus"
                      cSelect
                      (change)="validaEstatus($event.target.value)"
                    >
                      <option
                        *ngFor="let element of status"
                        [value]="element.valor"
                      >
                        {{ element.texto }}
                      </option>
                    </select>
                  </div>
                </c-col>
              </c-row>

              <hr class="mt-4 mb-4" />
              <c-row>
                <c-col>
                  <label cLabel>Tipo de Persona</label>
                  <select
                    aria-label="Default select example"
                    formControlName="typePerson"
                    cSelect
                  >
                    <option
                      *ngFor="
                        let element of listaTipoPersona.valueSetDetailResponse
                      "
                      [value]="element.cveValue"
                    >
                      {{ element.cveValue }} {{ element.description }}
                    </option>
                  </select>
                </c-col>

                <c-col>
                  <label cLabel>Ruta</label>
                  <select
                    aria-label="Default select example"
                    formControlName="ruta"
                    cSelect
                  >
                    <option
                      *ngFor="let element of listaRutasParaDescripcion"
                      [(ngValue)]="element.routeId"
                    >
                      {{ element.routeDescription }}
                    </option>
                  </select>
                </c-col>
                <c-col>
                  <label cLabel>Socio con Contrato</label>
                  <select
                    aria-label="Default select example"
                    formControlName="socioContrato"
                    cSelect
                  >
                    <option value="SI">SI</option>
                    <option value="NO">NO</option>
                  </select>
                </c-col>
              </c-row>
              <c-row class="mt-2">
                <c-col>
                  <label cLabel>Número de Acciones</label>
                  <input
                    cFormControl
                    id="noAcciones"
                    placeholder=""
                    type="number"
                    pattern="[0-9]+"
                    formControlName="noAcciones"
                  />
                </c-col>

                <c-col>
                  <label cLabel>Premio Certif. FDA ?</label>
                  <select
                    aria-label="Default select example"
                    formControlName="premioFDA"
                    cSelect readonly
                  >
                    <option [value]="1">SI</option>
                    <option [value]="2">NO</option>
                  </select>
                </c-col>
                <c-col>
                  <label cLabel>Flete</label>
                  <input
                    cFormControl
                    id="flete"
                    placeholder=""
                    type="number"
                    formControlName="flete"
                  />
                </c-col>
                <c-col>
                  <label cLabel>Grupo Compensación</label>

                  <select
                    aria-label="Default select example"
                    formControlName="compensacion"
                    cSelect
                  >
                    <option [ngValue]="null">Sin Grupo</option>
                    <option
                      *ngFor="let element of listaGrupoCompensacionLogistica"
                      [value]="element.cveValue"
                    >
                      {{ element.cveValue }} {{ element.description }}
                    </option>
                  </select>
                  <!-- <input
                    cFormControl
                    id="compensacion"
                    placeholder=""
                    type="text"
                    formControlName="compensacion"
                  /> -->
                </c-col>

                <c-col>
                  <label cLabel>Premio BPP</label>
                  <select formControlName="premioBPP" cSelect readonly>
                    <option value="SI">SI</option>
                    <option value="NO">NO</option>
                  </select>
                </c-col>
              </c-row>

              <hr class="mt-4 mb-4" />

              <c-row>
                <c-col [xs]="6">
                  <c-button-group
                    class="table"
                    aria-label="Basic example"
                    role="group"
                  >
                    <button
                      (click)="showRegresarSocio()"
                      cButton
                      color="primary"
                    >
                      Regresar
                    </button>
                  </c-button-group>
                </c-col>

                <c-col [xs]="6">
                  <c-button-group
                    class="table"
                    aria-label="Basic example"
                    role="group"
                  >
                    <button cButton color="primary" type="submit">
                      Guardar
                    </button>
                  </c-button-group>
                </c-col>
              </c-row>
            </form>
          </c-col>
        </c-row>
      </c-card-body>
    </c-card>
  </c-col>
</c-row>
